import React, { FC } from 'react'

import { ArrowRightIcon, IconSizes } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './FullTourStepFive.module.scss'
import { TimesheetPath } from './FullTourStepFive.types'

export const FullTourStepFive: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_tour.step_five'
  })
  const paths = t('paths', { returnObjects: true }) as TimesheetPath[]

  return (
    <section
      className={styles.tourCard}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-tour-step-five-title'
      aria-describedby='full-tour-step-five-description'
    >
      <div className={styles.tourMain}>
        <div className={styles.tourLeft}>
          <div className={styles.tourHeading}>
            <p className={styles.tourEyebrow}>{t('eyebrow')}</p>
            <h1 id='full-tour-step-five-title' className={styles.tourTitle}>
              <span>{t('title_before')}</span>
              <span className={styles.titleHighlight}>
                {t('title_highlighted')}
              </span>
            </h1>
          </div>

          <div
            id='full-tour-step-five-description'
            className={styles.tourDescription}
          >
            <p>{t('description_first')}</p>
            <p>{t('description_second')}</p>
          </div>
        </div>

        <ol className={styles.paths}>
          {paths.map((path, index) => (
            <li key={path.title} className={styles.pathCard}>
              <span className={styles.pathNumber} aria-hidden='true'>
                {index + 1}
              </span>
              <div className={styles.pathContent}>
                <h2>{path.title}</h2>
                <div className={styles.pathChips} aria-label={t('path_label')}>
                  {path.chips.map((chip, chipIndex) => (
                    <React.Fragment key={chip}>
                      {chipIndex > 0 && (
                        <ArrowRightIcon
                          aria-hidden='true'
                          color='var(--white)'
                          size={IconSizes.Size16}
                        />
                      )}
                      <span className={styles.pathChip}>{chip}</span>
                    </React.Fragment>
                  ))}
                </div>
                <p>{path.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
